export const getFormattedDate = (dateString) => {
	if (!dateString || typeof dateString !== "string") return ""
	return dateString.replace(/ /g, "+")
}
